import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import { useContext } from '../Context';

export default function W9FormButton() {
  const { dispatch, actions, state } = useContext();
  const [loading, setLoading] = useState(false);

  const onClick = () => {
    setLoading(true);
    actions.w9FormLink((data) => {
      setLoading(false);
      if (data.data) {
        window.open(data.data, '_blank');
      }
    });
  };

  return (
    <Button
      className={loading ? 'not-possible-click w-200 mt20' : 'w-200 mt20'}
      onClick={onClick}
      bsStyle="primary"
    >
      {loading ? 'Download W-9 Form ...' : 'Download W-9 Form'}
    </Button>
  );
}
